// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"738":"0566b351","1630":"f4bd3661","2827":"20011c27","5452":"0566b351","6248":"db4b8229","6341":"37b51cff"}[chunkId] + ".chunk.css";
};